export default __webpack_public_path__ + "static/media/logodark.a21b554c.png";